import { AggregationPeriod, AggregationTimeInterval, Period } from "../../../../../../services/stats/models";
import moment, { Moment } from "moment";

export interface IPeriodOption{
    title: string,
    aggregationTimeInterval: AggregationTimeInterval,
    from: Moment,
    to: Moment,
    periodName: Period
}

// TODO: move to separate moment wrapper
moment.locale('en', {
    week : {
        dow : 1,
        doy : 4
    }
});
moment.locale('ru', {
    week : {
        dow : 1,
        doy : 4
    }
});


const periodOptions: IPeriodOption[] = [
    {
        title: "today",
        aggregationTimeInterval: {
            amount: 1,
            period: AggregationPeriod.days
        },
        from: moment().startOf("day"),
        to: moment().endOf("day"),
        periodName: Period.today
    },
    {
        title: "yesterday",
        aggregationTimeInterval: {
            amount: 1,
            period: AggregationPeriod.days
        },
        from: moment().subtract(1, "day").startOf("day"),
        to: moment().startOf("day"),
        periodName: Period.yesterday
    },
    {
        title: "beginningOfWeek",
        aggregationTimeInterval: {
            amount: 4,
            period: AggregationPeriod.days
        },
        from: moment().startOf("week"),
        to: moment().endOf("day"),
        periodName: Period.beginning_week
    },
    {
        title: "lastWeek",
        aggregationTimeInterval: {
            amount: 4,
            period: AggregationPeriod.days
        },
        from: moment().startOf("week").subtract(1, 'week'),
        to: moment().startOf("week"),
        periodName: Period.previous_week
    },
    {
        title: "beginningOfMonth",
        aggregationTimeInterval: {
            amount: 4,
            period: AggregationPeriod.days
        },
        from: moment().startOf("month"),
        to: moment().endOf("day"),
        periodName: Period.beginning_month
    },
    {
        title: "lastMonth",
        aggregationTimeInterval: {
            amount: 4,
            period: AggregationPeriod.days
        },
        from: moment().startOf("month").subtract(1, 'month'),
        to: moment().startOf("month"),
        periodName: Period.previous_month
    },
    {
        title: "beginningOfQuarter",
        aggregationTimeInterval: {
            amount: 1,
            period: AggregationPeriod.days
        },
        from: moment().startOf("quarter"),
        to: moment().endOf("day"),
        periodName: Period.beginning_quarter
    },
    {
        title: "lastQuarter",
        aggregationTimeInterval: {
            amount: 1,
            period: AggregationPeriod.days
        },
        from: moment().startOf("quarter").subtract(1, 'quarter'),
        to: moment().startOf("quarter"),
        periodName: Period.previous_quarter
    },
    {
        title: "beginningOfYear",
        aggregationTimeInterval: {
            amount: 1,
            period: AggregationPeriod.weeks
        },
        from: moment().startOf("year"),
        to: moment().endOf("day"),
        periodName: Period.beginning_year
    },
    {
        title: "lastYear",
        aggregationTimeInterval: {
            amount: 1,
            period: AggregationPeriod.weeks
        },
        from: moment().startOf("year").subtract(1, 'year'),
        to: moment().startOf("year"),
        periodName: Period.previous_year
    },
];


export default periodOptions
